import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DescripcionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='DESCRIPCIÓN' htmlFor='input-descripcion' md={4} />
      <Col md={8}>
        <Field name='descripcion'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-descripcion'
              placeholder='Ingresar descripcion ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DescripcionFormGroup)
